import { render } from "./Queries.vue?vue&type=template&id=2091b6e6&scoped=true"
import script from "./Queries.vue?vue&type=script&lang=js"
export * from "./Queries.vue?vue&type=script&lang=js"

import "./Queries.vue?vue&type=style&index=0&id=2091b6e6&scoped=true&lang=css"
import "./Queries.vue?vue&type=style&index=1&id=2091b6e6&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2091b6e6"]])

export default __exports__